import React, { useEffect, useState } from 'react';
import { contentsAPIV2 } from '@/utils/contentsApi';
import HomepageFocusProductCard from '@/app/components/Card/HomepageFocusProductCard';
import HomepageTopProductCard from '@/app/components/Card/HomepageTopProductCard';

function HomepageFiveProductCarousel({ section }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const contentsData = {
          sectionId: section?.id,
          contentType: section?.content_type,
        };
        const response = await contentsAPIV2(contentsData);
        if (response) {
          setData([...response.items]);
        }
      } catch (err) {
        console.warn('Error fetching data:', err);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="container 3xl:max-w-[1440px] mx-auto mb-32 lg:mb-[57px] lg:mt-12">
      {Array.isArray(data) && data?.length > 0
        ? data?.slice(0, 1)?.map((productOne) => (
            <div
              className="flex flex-col lg:flex-row gap-[20px]"
              key={productOne?.slug}
            >
              <HomepageFocusProductCard
                productId={productOne?.id}
                key={productOne?.id}
                product={productOne}
                productImages={productOne?.images}
                price={parseFloat(productOne?.price?.final_price)}
                save={productOne?.price?.discount?.discount_text ?? ''}
              />
              <div className="w-full lg:w-[50%] grid grid-cols-2 gap-[20px]">
                {data?.slice(1, 5)?.map((productTwo) => (
                  <HomepageTopProductCard
                    key={productTwo?.id}
                    productId={productTwo?.id}
                    product={productTwo}
                    productImages={productTwo?.images}
                    price={parseFloat(productTwo?.price?.final_price)}
                    save={productTwo?.price?.discount?.discount_text ?? ''}
                  />
                ))}
              </div>
            </div>
          ))
        : null}
    </div>
  );
}

export default HomepageFiveProductCarousel;
